<template>
	<div class="assess">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>评价详情</span>
			<span></span>
		</div>
		<!-- 填写内容 -->
		<van-panel class="sale">
			<div class="content">
				<div class="list">
					<van-cell class="sale_stars">
						<van-rate v-model="stars" allow-half void-icon="star" size="1rem" gutter="0.5rem" readonly color="#F1452F" />
					</van-cell>
					<van-cell>
						<div slot="title" class="title">
							<div v-for="item in score" :class="{'popup-active': radio == item.code}" @click="radio=item.code">{{item.name}}</div>
						</div>
					</van-cell>
					<van-cell-group>
						<van-field v-model="message" rows="2" autosize type="textarea" maxlength="200" placeholder="请填写您的评论"
						 show-word-limit />
						<van-uploader multiple v-model="fileList" :max-count="4" />
					</van-cell-group>
					<van-cell>
						<div slot="title">
							<div class="status status_acticve_open" v-if="anonymous" @click="anonymous = !anonymous">
								<img src="../../assets/open.png" alt="">
								<span>公开</span>
							</div>
							<div class="status status_acticve_hide" v-else @click="anonymous = !anonymous">
								<img src="../../assets/hide.png" alt="">
								<span>匿名</span>
							</div>
						</div>
					</van-cell>
				</div>
			</div>
		</van-panel>
		<van-button type="danger" round @click="submit">提交</van-button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				radio: 2,
				message: '',
				anonymous: true,
				formArray: [],
				fileList: [],
				stars: 2.5,
				score: [{
					name: '好评',
					code: 1
				}, {
					name: '中评',
					code: 2
				}, {
					name: '差评',
					code: 3
				}]
			}
		},
		methods: {
			submit() {
				const toast = this.$toast.loading({
					duration: 0,
					forbidClick: true,
					message: '提交中',
					loadingType: 'spinner'
				});
				if (this.radio === 0) {
					this.$toast('请选择评价！');
					return false;
				}
				if (this.message == '') {
					this.$toast('评论不能为空！');
					return false;
				};
				if (this.anonymous == true) {
					this.anonymous = 1
				} else {
					this.anonymous = 2
				}
				var data = {};
				data['thirdparty_id'] = this.$route.query.id;
				data['hot_num'] = this.radio;
				data['content'] = this.message;
				data['anonymous'] = this.anonymous;
				data['token'] = localStorage.getItem('Authorization');
				let formData = new FormData();
				for (let key in this.fileList) {
					formData.append('file[]', this.fileList[key].file);
				}
				if (formData.has("file[]")) {
					this.upload(formData, (res) => {
						for (let i in res) {
							this.formArray.push(res[i])
						}
					});
					data['image'] = this.formArray;
				}
				setTimeout(() => {
					this.$axios.post(baseUrl + '/mobile/category/thirdpartyAddComment', data).then((res) => {
						if (res.data.code == 5) {
							this.$toast('评论成功');
							this.back();
							this.$toast.clear();
						}
					}).catch((err) => {})
				}, 500)
			}
		},
		watch: {
			'radio': function(value) {
				switch (value) {
					case 1:
						this.stars = 5;
						break;
					case 2:
						this.stars = 2.5;
						break;
					case 3:
						this.stars = 0;
						break;
				}
			}
		}
	}
</script>

<style scoped>
	@import '../min/assess.css';

	.assess .van-panel__header {
		padding: 0;
	}

	.assess .van-uploader {
		margin-top: 0.5rem;
	}

	.assess .van-panel {
		background: #fff;
	}

	.assess .van-button {
		height: 2rem;
		line-height: 2rem;
		font-size: 0.75rem;
		width: 70%;
		margin-top: 3rem;
	}

	.assess .sale .sale_stars {
		padding-top: 0;
		padding-bottom: 0;
		margin-top: 1.5rem;
		align-items: center;
	}

	.assess .sale .title div {
		border-radius: 0.2rem;
		text-align: center;
		width: 3rem;
		height: 1.5rem;
		line-height: 1.5rem;
		font-size: 0.75rem;
		color: #666;
		background: #f2f2f2;
		margin-right: 1rem;
	}

	.assess .sale .title .popup-active {
		border-radius: 0.2rem;
		border: 1px solid #F1452F;
		color: #fff;
		background: #F1452F;
		box-sizing: border-box;
	}

	.assess .van-cell .van-rate {
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/class/score.vue